import styled from 'styled-components';

export const MainBodyStyle = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  font-family: Arial, sans-serif;
  background: #f0f0f0;
  .header {
    height: 7.5%;
    width: 100%;
    border: 1px solid #ccc;
    background-color: white;
  }
  .control-panel {
    height: 15%;
    width: 99.2%;
    background: #ffffff;
    border: 1px solid #ccc;
    margin-top: 7px;
  }
  .control-panel .first-row {
    text-align: left;
    padding: 5px;
    height: 50%;
    font-size: 13px;
    font-weight: 700;
    line-height: 16px;
    font-family: 'lg-smart', sans-serif;
    color: #6b6b6b;
  }
  .control-panel .third-row {
    height: 20%;
    margin-top: 20px;
  }
  .fourth-row {
    height: 50px;
    width: 98.5%;
    background-color: #f0f6f7;
    display: flex;
    align-items: center;
    margin-left: 0.75%;
    margin-top: 8px;
    border-top: 1px solid #ccc;
    border-left: 1px solid #ccc;
    border-right: 1px solid #ccc;
  }
  .main-data-row {
    background-color: white;
    height: 74.5%;
    width: 98.5%;
    border: 1px solid #ccc;
    margin-left: 0.75%;
    overflow-x: hidden;
  }
`;
